import { COMMUNITIES, QUESTIONS } from './reflectQuestions';
import { ANSWERS } from './reflectAnswers';
import { OPPORTUNITIES } from './reflectOpportunities';

// State-level community counts (top states, simulated)
export const STATE_COMMUNITIES = {
  California: 420, Texas: 380, Florida: 310, 'New York': 290,
  Illinois: 210, Pennsylvania: 190, Ohio: 180, Georgia: 170,
  'North Carolina': 160, Michigan: 150, Arizona: 140, Virginia: 130,
  Washington: 120, Massachusetts: 115, Colorado: 105
};

export const getCommunity = (condition) => {
  return COMMUNITIES[condition] || COMMUNITIES._default;
};

export const getQuestionsForCondition = (condition) => {
  return QUESTIONS[condition] || QUESTIONS._default;
};

export const getAnswersForQuestion = (questionId) => {
  return ANSWERS[questionId] || ANSWERS['general-q1'];
};

export const getOpportunities = (condition) => {
  return OPPORTUNITIES[condition] || OPPORTUNITIES._default;
};
